import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, CircleMarker, useMapEvents } from "react-leaflet";

const Clicker = ({ onPick }) => {
  useMapEvents({ click: (e) => onPick(+e.latlng.lat.toFixed(6), +e.latlng.lng.toFixed(6)) });
  return null;
};

export const LocationPicker = ({ lat, lng, onPick, readOnly }) => {
  const has = lat != null && lng != null && lat !== "" && lng !== "";
  return (
    <div className="space-y-1.5">
      <div className="h-56 rounded-md overflow-hidden border border-stone-200 relative z-0" data-testid="location-picker">
        <MapContainer center={has ? [lat, lng] : [36.75, 3.06]} zoom={has ? 14 : 6} style={{ height: "100%", width: "100%" }}>
          <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {!readOnly && <Clicker onPick={onPick} />}
          {has && <CircleMarker center={[lat, lng]} radius={9} pathOptions={{ color: "#C2410C", fillColor: "#C2410C", fillOpacity: 0.8 }} />}
        </MapContainer>
      </div>
      <p className="text-xs text-stone-500" data-testid="location-coords">{has ? `Position : ${lat}, ${lng}` : "Aucune position"}{!readOnly && " — cliquez sur la carte pour placer le cabinet"}</p>
    </div>
  );
};
